import {useEffect, useState, useContext} from 'react';
import {Box, Fab} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {
  matchPath,
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import {OfficeContextType, VoximplantProcessState} from '../../contexts/office/types';
import {OfficeContext} from '../../contexts/office/context';
import {AppContextType} from '../../contexts/app/types';
import {AppContext} from '../../contexts/app/context';
import {SnackBarContextType} from '../../contexts/snack-bar/types';
import {SnackBarContext} from '../../contexts/snack-bar/context';
import {UserType} from '../../backend/enums/user-type';
import {translations} from '../../i18n/translations';
import {UsersRepository} from '../../repositories/users';
import {User} from '../../backend/interfaces/user';
import {ContentPage} from '../content-page/content-page';
import {SectionTabs} from '../section-tabs/section-tabs';
import {SubmitButtonState} from '../submit-button/submit-button';
import {SeniorTabsType} from '../../enums/senior-tabs-type';
import SeniorProfileProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/profile/senior-profile.professional-caregiver.screen';
import SeniorActivityProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/activity/senior-activity.professional-caregiver.screen';
import SeniorStatisticsProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/statistics/senior-statistics.professional-caregiver.screen';
import SeniorApplicationsProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/applications/senior-applications.professional-caregiver.screen';
import SeniorDevicesProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/devices/senior-devices.professional-caregiver.screen';
import SeniorUserCardsProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/user-cards/senior-user-cards.professional-caregiver.screen';
import SeniorHealthProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/health/senior-health.professional-caregiver.screen';
import SeniorInformalCaregiversProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/informal-caregivers/senior-informal-caregivers.professional-caregiver.screen';
import SeniorInviteInformalCaregiverProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/invite-informal-caregiver/senior-invite-informal-caregiver.professional-caregiver.screen';
import SeniorInvitesHistoryProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/invites-history/senior-invites-history.professional-caregiver.screen';
import SeniorAssociateUserCardProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/associate-user-card/senior-associate-user-card.professional-caregiver.screen';
import SeniorAssociateDeviceProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/associate-device/senior-associate-device.professional-caregiver.screen';
import SeniorProfileSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/profile/senior-profile.system-administrator.screen';
import SeniorActivitySystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/activity/senior-activity.system-administrator.screen';
import SeniorStatisticsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/statistics/senior-statistics.system-administrator.screen';
import SeniorApplicationsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/applications/senior-applications.system-administrator.screen';
import SeniorDevicesSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/devices/senior-devices.system-administrator.screen';
import SeniorUserCardsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/user-cards/senior-user-cards.system-administrator.screen';
import SeniorHealthSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/health/senior-health.system-administrator.screen';
import SeniorInformalCaregiverSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/informal-caregivers/senior-informal-caregivers.system-administrator.screen';
import SeniorInviteInformalCaregiverSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/invite-informal-caregiver/senior-invite-informal-caregiver.system-administrator.screen';
import SeniorInvitesHistorySystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/invites-history/senior-invites-history.system-administrator.screen';
import SeniorAssociateUserCardSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/associate-user-card/senior-associate-user-card.system-administrator.screen';
import SeniorAssociateDeviceSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/associate-device/senior-associate-device.system-administrator.screen';
import SeniorAffiliationsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/affiliations/senior-affiliations.system-administrator.screen';
import SeniorExternalAccountsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/external-accounts/senior-external-accounts.system-administrator.screen';
import SeniorAssociateExternalAccountSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/associate-external-account/senior-associate-external-account.system-administrator.screen';
import SeniorExternalAccountSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/external-account/senior-external-account.system-administrator.screen';
import SeniorPlaylistsProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/playlists/senior-playlists.professional-caregiver.screen';
import SeniorPlaylistItemsProfessionalCaregiverOfficeScreen from '../../screens/private/office/professional-caregiver/seniors/edit/playlists/senior-playlist-items.professional-caregiver.screen';
import SeniorPlaylistsSystemAdministratorOfficeScreen from '../../screens/private/office/system-administrator/seniors/edit/playlists/senior-playlists.system-administrator.screen';
import CallIcon from '@mui/icons-material/Call';
import eventEmitter from '../../events/event-emitter';
import {CREATE_VIDEOCALL} from '../../events/event-types';
import {CallContext} from '../../enums/call-context';
import {AuthContextType} from '../../contexts/auth/types';
import {AuthContext} from '../../contexts/auth/context';
import {Tooltip} from '../tooltip/tooltip';

enum SeniorSectionTabs {
  Profile = 'profile',
  Caregivers = 'caregivers',
  Applications = 'applications',
  Devices = 'devices',
  Activity = 'activity',
  Statistics = 'statistics',
  Health = 'health',
  UserCards = 'user-cards',
  Affiliations = 'affiliations',
  Playlists = 'playlists',
  ExternalAccounts = 'external-accounts',
}

enum PathExtensions {
  Caregivers = 'caregivers',
  Applications = 'applications',
  Devices = 'devices',
  Activity = 'activity',
  Statistics = 'statistics',
  InviteCaregiver = 'caregivers/invite',
  InvitesHistory = 'caregivers/invites',
  Health = 'health',
  UserCards = 'user-cards',
  AssociateUserCard = 'user-cards/associate',
  AssociateDevice = 'devices/associate',
  Affiliations = 'affiliations',
  Playlists = 'playlists',
  PlaylistItems = 'playlists/:playlistId',
  ExternalAccounts = 'external-accounts',
  AssociateExternalAccount = 'external-accounts/associate',
  ExternalAccount = 'external-accounts/:type',
}

/**
 * Senior navigation tabs used to navigate between the senior's screen.
 *
 * Permissions are given by props.
 */
export const SeniorTabs = (props: {type: SeniorTabsType}) => {
  // Get params
  let {id}: {id?: string} = useParams();
  if (id?.toLowerCase() === 'create') {
    id = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {path, url} = useRouteMatch();

  // Get navigation info
  let history = useHistory();

  // Translations
  const {t} = useTranslation();

  // Get context
  const authContext: AuthContextType = useContext(AuthContext);
  const snackBarContext: SnackBarContextType = useContext(SnackBarContext);
  const appContext: AppContextType = useContext(AppContext);
  const officeContext: OfficeContextType = useContext(OfficeContext);
  const isVoximplantReadyForOutgoingCalls =
    officeContext.state.voximplant.connectionState === VoximplantProcessState.Done &&
    officeContext.state.voximplant.signedInState === VoximplantProcessState.Done &&
    !officeContext.state.voximplant.degraded;

  // Get current tab based on the location
  const handleGetCurrentTab = (pathname: string) => {
    if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Activity}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Activity;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Statistics}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Operator ||
        props.type === SeniorTabsType.SystemAdministrator_Statistics)
    ) {
      return SeniorSectionTabs.Statistics;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Applications}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Applications;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Caregivers}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Caregivers;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Devices}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Devices;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Health}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Health;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.UserCards}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.UserCards;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.InviteCaregiver}`,
        exact: true,
        strict: false,
      })
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.InvitesHistory}`,
        exact: true,
        strict: false,
      })
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.AssociateUserCard}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
        props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.AssociateDevice}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
        props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Affiliations}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return SeniorSectionTabs.Affiliations;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.Playlists}`,
        exact: true,
        strict: false,
      })
    ) {
      return SeniorSectionTabs.Playlists;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.PlaylistItems}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
        props.type === SeniorTabsType.ProfessionalCaregiver_Operator)
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.ExternalAccounts}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return SeniorSectionTabs.ExternalAccounts;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.AssociateExternalAccount}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return undefined;
    } else if (
      matchPath(pathname, {
        path: `${path}/${PathExtensions.ExternalAccount}`,
        exact: true,
        strict: false,
      }) &&
      (props.type === SeniorTabsType.SystemAdministrator_Statistics ||
        props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics)
    ) {
      return undefined;
    }

    // Default
    return SeniorSectionTabs.Profile;
  };

  // Hold state
  const [currentTab, setCurrentTab] = useState<SeniorSectionTabs | undefined>(
    handleGetCurrentTab(window.location.pathname)
  );

  // Listen for route changes
  useEffect(() => {
    // Listen for route changes
    const routeChangesUnsubscribe = history.listen((location: any) => {
      // Let's update the current tab
      setCurrentTab(handleGetCurrentTab(location.pathname));
    });

    // Clean up
    return () => {
      // Unsubscribe
      routeChangesUnsubscribe();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, path]);

  // Validate and get the user
  useEffect(() => {
    const getUser = async () => {
      if (id) {
        try {
          // Get user
          const userDetails: User = await UsersRepository.instance.getById(id);

          if (userDetails) {
            // Set user for edit/view
            officeContext.setUserForm(userDetails);
          } else {
            // Error
            throw new Error('Empty user.');
          }
        } catch (error) {
          // Log
          console.debug('🔴 Could not get user.', error);

          // Show toast error
          snackBarContext.setOfficeToastNotification({
            severity: 'error',
            message: t(translations.senior_tabs.errors.senior_does_not_exist_error),
          });

          // Redirect
          history.push(`${url.replace(`/${id}`, '')}`);
        }
      } else {
        // Set user for create
        officeContext.setUserForm({
          id: undefined,
          product: appContext.state.configuration.product,
          type: UserType.Senior,
          name: '',
          isActive: true,
          email: undefined,
          picture: undefined,
          birthday: undefined,
          phoneNumber: undefined,
          taxPayerNumber: undefined,
          gender: undefined,
          address: undefined,
          languageCode: undefined,
          religion: undefined,
          occupationId: undefined,
          region: undefined,
        });
      }
    };

    // Get user
    getUser();

    // Clean up
    return () => {
      // Clear user
      officeContext.clearUserForm();

      // Log
      console.debug('🧹 User form cleaned in office context.');
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Tabs
  const tabs = [
    {
      value: SeniorSectionTabs.Profile,
      label: t(translations.senior_tabs.tabs.profile),
      href: url,
    },
    {
      value: SeniorSectionTabs.Caregivers,
      label: t(translations.senior_tabs.tabs.caregivers),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Caregivers}`
          : `${url}/${PathExtensions.Caregivers}`,
    },
    {
      value: SeniorSectionTabs.Applications,
      label: t(translations.senior_tabs.tabs.applications),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Applications}`
          : `${url}/${PathExtensions.Applications}`,
    },
    {
      value: SeniorSectionTabs.Devices,
      label: t(translations.senior_tabs.tabs.devices),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Devices}`
          : `${url}/${PathExtensions.Devices}`,
    },
    {
      value: SeniorSectionTabs.UserCards,
      label: t(translations.senior_tabs.tabs.user_cards),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.UserCards}`
          : `${url}/${PathExtensions.UserCards}`,
    },
    {
      value: SeniorSectionTabs.Health,
      label: t(translations.senior_tabs.tabs.health),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Health}`
          : `${url}/${PathExtensions.Health}`,
    },
    {
      value: SeniorSectionTabs.Activity,
      label: t(translations.senior_tabs.tabs.activity),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Activity}`
          : `${url}/${PathExtensions.Activity}`,
    },
    {
      value: SeniorSectionTabs.Playlists,
      label: t(translations.senior_tabs.tabs.playlists),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Playlists}`
          : `${url}/${PathExtensions.Playlists}`,
    },
  ];
  if (
    props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
    props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
    props.type === SeniorTabsType.ProfessionalCaregiver_Operator ||
    props.type === SeniorTabsType.SystemAdministrator_Statistics
  ) {
    tabs.push({
      value: SeniorSectionTabs.Statistics,
      label: t(translations.senior_tabs.tabs.statistics),
      href:
        url.charAt(url.length - 1) === '/'
          ? `${url}${PathExtensions.Statistics}`
          : `${url}/${PathExtensions.Statistics}`,
    });
  }

  // Only professional caregivers that are managers or administrators can associate/dissociate
  // devices and cards. All other professional caregivers can only view.
  return (
    <ContentPage>
      {id && (
        <Box sx={{marginBottom: '16px'}}>
          <SectionTabs
            title={officeContext.state.userForm ? officeContext.state.userForm.user.name : ''}
            titleAvatar={
              currentTab !== SeniorSectionTabs.Profile
                ? {
                    url: officeContext.state.userForm?.user.picture,
                    type: 'user',
                  }
                : undefined
            }
            currentTab={currentTab}
            tabs={
              props.type === SeniorTabsType.SystemAdministrator_Statistics ||
              props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics
                ? [
                    ...tabs.slice(0, 2),
                    {
                      value: SeniorSectionTabs.Affiliations,
                      label: t(translations.senior_tabs.tabs.affiliations),
                      href:
                        url.charAt(url.length - 1) === '/'
                          ? `${url}${PathExtensions.Affiliations}`
                          : `${url}/${PathExtensions.Affiliations}`,
                    },
                    ...tabs.slice(2, 5),
                    {
                      value: SeniorSectionTabs.ExternalAccounts,
                      label: t(translations.senior_tabs.tabs.external_accounts),
                      href:
                        url.charAt(url.length - 1) === '/'
                          ? `${url}${PathExtensions.ExternalAccounts}`
                          : `${url}/${PathExtensions.ExternalAccounts}`,
                    },
                    ...tabs.slice(5),
                  ]
                : tabs
            }
            exitUrl={`${url.replace(`/${id}`, '')}`}
            disabled={
              officeContext.state.userFormSubmitButtonState === SubmitButtonState.Loading ||
              officeContext.state.userFormDeleteButtonState === SubmitButtonState.Loading ||
              officeContext.state.informalCaregiverInviteFormSubmitButtonState ===
                SubmitButtonState.Loading ||
              officeContext.state.associateUserCardFormSubmitButtonState ===
                SubmitButtonState.Loading ||
              officeContext.state.associateDeviceFormSubmitButtonState === SubmitButtonState.Loading
            }
            rightButtons={
              <Tooltip.NotAllowedIf
                condition={!isVoximplantReadyForOutgoingCalls}
                title={t(translations.videocall.incomingCallConnecting)}
                sx={{display: 'block'}}
              >
                <Fab
                  color="primary"
                  aria-label="call"
                  disabled={
                    !officeContext.state.userForm?.user.id || !isVoximplantReadyForOutgoingCalls
                  }
                  onClick={() => {
                    if (!isVoximplantReadyForOutgoingCalls) return;
                    eventEmitter.emit(
                      CREATE_VIDEOCALL,
                      officeContext.state.userForm?.user.id ?? '',
                      props.type.includes('system-administrator_')
                        ? CallContext.SystemAdministration
                        : CallContext.Affiliation,
                      !props.type.includes('system-administrator_')
                        ? authContext.state.session?.selectedAffiliation?.id
                        : undefined,
                      !props.type.includes('system-administrator_')
                        ? authContext.state.session?.selectedAffiliation?.entity.id
                        : undefined,
                      officeContext.state.userForm?.user.name
                    );
                  }}
                  size="medium"
                >
                  <CallIcon />
                </Fab>
              </Tooltip.NotAllowedIf>
            }
          />
        </Box>
      )}
      {/* Main content */}
      <Box>
        <Switch>
          {/* View/edit/create seniors */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={path}>
              <SeniorProfileProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior activity */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Activity}`}>
              <SeniorActivityProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior statistics */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Statistics}`}>
              <SeniorStatisticsProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior applications */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Applications}`}>
              <SeniorApplicationsProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior playlists */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Playlists}`}>
              <SeniorPlaylistsProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior playlist items */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.PlaylistItems}`}>
              <SeniorPlaylistItemsProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior devices */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Devices}`}>
              <SeniorDevicesProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior user cards */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.UserCards}`}>
              <SeniorUserCardsProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior health */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Health}`}>
              <SeniorHealthProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Senior informal caregivers */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.Caregivers}`}>
              <SeniorInformalCaregiversProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Invite informal caregiver */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.InviteCaregiver}`}>
              <SeniorInviteInformalCaregiverProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Caregiver relationship invites history */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Operator) && (
            <Route exact path={`${path}/${PathExtensions.InvitesHistory}`}>
              <SeniorInvitesHistoryProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Associate a user card */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager) && (
            <Route exact path={`${path}/${PathExtensions.AssociateUserCard}`}>
              <SeniorAssociateUserCardProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* Associate a device */}
          {(props.type === SeniorTabsType.ProfessionalCaregiver_Administrator ||
            props.type === SeniorTabsType.ProfessionalCaregiver_Manager) && (
            <Route exact path={`${path}/${PathExtensions.AssociateDevice}`}>
              <SeniorAssociateDeviceProfessionalCaregiverOfficeScreen />
            </Route>
          )}
          {/* View/edit/create seniors */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={path}>
              <SeniorProfileSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior activity */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Activity}`}>
              <SeniorActivitySystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior statistics */}
          {props.type === SeniorTabsType.SystemAdministrator_Statistics && (
            <Route exact path={`${path}/${PathExtensions.Statistics}`}>
              <SeniorStatisticsSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior applications */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Applications}`}>
              <SeniorApplicationsSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior devices */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Devices}`}>
              <SeniorDevicesSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior user cards */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.UserCards}`}>
              <SeniorUserCardsSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior health */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Health}`}>
              <SeniorHealthSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior informal caregivers */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Caregivers}`}>
              <SeniorInformalCaregiverSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Invite informal caregiver */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.InviteCaregiver}`}>
              <SeniorInviteInformalCaregiverSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Caregiver relationship invites history */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.InvitesHistory}`}>
              <SeniorInvitesHistorySystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Associate a user card */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.AssociateUserCard}`}>
              <SeniorAssociateUserCardSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Associate a device */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.AssociateDevice}`}>
              <SeniorAssociateDeviceSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior external accounts */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.ExternalAccounts}`}>
              <SeniorExternalAccountsSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Associate an external account */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.AssociateExternalAccount}`}>
              <SeniorAssociateExternalAccountSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* External account details */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.ExternalAccount}`}>
              <SeniorExternalAccountSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior affiliations */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Affiliations}`}>
              <SeniorAffiliationsSystemAdministratorOfficeScreen />
            </Route>
          )}
          {/* Senior playlists */}
          {(props.type === SeniorTabsType.SystemAdministrator_WithoutStatistics ||
            props.type === SeniorTabsType.SystemAdministrator_Statistics) && (
            <Route exact path={`${path}/${PathExtensions.Playlists}`}>
              <SeniorPlaylistsSystemAdministratorOfficeScreen />
            </Route>
          )}

          {/** Default route */}
          <Route path={path}>
            <Redirect to={url} />
          </Route>
        </Switch>
      </Box>
    </ContentPage>
  );
};
